<script setup>
import { ref } from 'vue';
import example1Img from '../../../../assets/images/example1.png';
import example2Img from '../../../../assets/images/example2.png';
import example3Img from '../../../../assets/images/example3.png';
import example4Img from '../../../../assets/images/example4.png';

const serviceCases = ref([
  {
    id: 1,
    title: '順德古樓宇風水堪輿',
    image: example1Img,
  },
  {
    id: 2,
    title: '百度風水堪輿',
    image: example2Img,
  },
  {
    id: 3,
    title: '新世界地產‧廣匯尊府',
    image: example3Img,
  },
  {
    id: 4,
    title: '南海·碧桂園',
    image: example4Img,
  },
]);
</script>

<template>
  <section class="service-case-section">
    <h2 class="section-title">服務案例</h2>
    <div class="cases-container">
      <div
        v-for="caseItem in serviceCases"
        :key="caseItem.id"
        class="case-card"
      >
        <div class="case-image-container">
          <img
            :src="caseItem.image"
            :alt="caseItem.title"
            class="case-image"
          />
        </div>
        <p class="case-title">{{ caseItem.title }}</p>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.service-case-section {
  width: 100%;
  padding: 0.3rem 0.2rem;
  background: #ffffff;
}

.section-title {
  font-size: 0.8rem;
  color: rgb(29, 32, 35);
  text-align: center;
  margin-bottom: 0.875rem;
}

.cases-container {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.case-card {
  width: 100%;
  background: #ffffff;
  overflow: hidden;
}

.case-image-container {
  width: 100%;
  overflow: hidden;

  .case-image {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
  }
}

.case-title {
  font-size: 0.5rem;
  color: #333333;
  text-align: center;
  padding: 0.5rem;
  margin: 0;
  line-height: 1.4;
}
</style>
